import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BasicQuestionConditionsComponent } from './question-conditions.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [BasicQuestionConditionsComponent],
  exports: [BasicQuestionConditionsComponent]
})
export class QuestionConditionsModule {}
